import React, { useMemo, useState, useEffect } from 'react'
import { useParams, useNavigate } from 'react-router-dom'
import './Product.scss'
import './Shopify.scss'
import { getDprImageUrl } from '../utils/imageLoader'
import { motion, AnimatePresence } from 'framer-motion'



const Product = ({ products = [] }) => {
    const { id } = useParams()
    const navigate = useNavigate()

    const product = useMemo(
        () => products.find((p) => String(p.url) === String(id)),
        [products, id]
    )

    const images = useMemo(() => (
        product?.photos?.length ? product.photos : product?.src ? [product.src] : []
    ), [product])
    const optimizedImages = useMemo(() => images.map((u) => getDprImageUrl(u, 750)), [images])

    const [index, setIndex] = useState(0)

    const handleClick = () => {
        if (!optimizedImages.length) return
        setIndex((prev) => (prev + 1) % optimizedImages.length)
    }

    const handleBackgroundClick = (e) => {
        const el = e.target
        if (el && el.closest) {
            // don't navigate when clicking the image or interactive controls
            if (el.closest('.viewer img')) return
            if (el.closest('button, a, input, select, textarea, .shopify-addtocard-button')) return
        }
        navigate(-1)
    }

    // Load Shopify Buy Button and render product component into the container
    useEffect(() => {
        if (!product?.shopifyBuyId || !product?.productComponentId) {
            console.log('Skipping Shopify Buy Button: missing IDs', { shopifyBuyId: product?.shopifyBuyId, productComponentId: product?.productComponentId });
            return;
        }

        const scriptURL = 'https://sdks.shopifycdn.com/buy-button/latest/buy-button-storefront.min.js';
        const containerId = `product-component-${product.productComponentId}`;

        let removeToggleListener = null;

        function ShopifyBuyInit() {
            if (!window.ShopifyBuy) return;
            const client = window.ShopifyBuy.buildClient({
                domain: 'bxi4sc-dj.myshopify.com',
                storefrontAccessToken: 'ce06086628522497d86426cd11e4c0f7',
            });
            window.ShopifyBuy.UI.onReady(client).then((ui) => {
                const node = document.getElementById(containerId);
                if (!node) {
                    console.error('Shopify container not found:', containerId);
                    return;
                }

                // Read CSS variables from the container
                const styles = getComputedStyle(node);
                const getVar = (name) => styles.getPropertyValue(name).trim();

                node.innerHTML = '';
                ui.createComponent('product', {
                    id: String(product.shopifyBuyId),
                    node: document.getElementById(containerId),
                    moneyFormat: '%E2%82%AC%7B%7Bamount_with_comma_separator%7D%7D',
                    options: {
                        product: {
                            styles: {
                                product: {
                                    '@media (min-width: 601px)': {
                                        'max-width': 'calc(25% - 20px)',
                                        'margin-left': '20px',
                                        'margin-bottom': '50px',
                                    },
                                },
                                quantityContainer: { // doesnt work 
                                    'display': 'none',
                                },
                                button: {
                                    'font-family': '"Josefin Sans", sans-serif',
                                    'font-size': getVar('--shopify-button-font-size'),
                                    // 'padding': getVar('--shopify-button-padding'),
                                    'background-color': 'transparent',
                                    'color': '#5a0135',
                                    'font-weight': '700',
                                    'padding': '0',
                                    // 'text-decoration': 'underline',

                                    // 'border': '1px solid #5a0135',

                                    //'border-radius': getVar('--shopify-button-border-radius'),
                                    ':hover': {
                                        'background-color': 'transparent',
                                    },
                                    ':focus': {
                                        'background-color': 'transparent',
                                    },
                                    ':disabled': {
                                        'background-color': 'transparent',
                                        'background': 'transparent',
                                        'box-shadow': 'none',
                                        'border': 'none',
                                        'color': '#5a0135',
                                        'text-decoration': 'line-through',
                                    },
                                },
                                buttonWrapper: {

                                    //'padding': '0 !important',
                                    // 'width': 'fit-content !important',
                                    //'background': 'blue !important',
                                    'text-align': 'right !important',



                                },
                                quantityInput: {
                                    'font-size': getVar('--shopify-button-font-size'),
                                    'padding-top': '14.5px',
                                    'padding-bottom': '14.5px',
                                    'color': '#5a0135',
                                },
                            },
                            googleFonts: ['Josefin Sans:700'],
                            contents: {
                                img: false,
                                title: false,
                                price: false,
                            },
                            text: {
                                button: 'ajouter au panier',
                                outOfStock: 'ajouter au panier',
                            },
                        },
                        productSet: {
                            styles: {
                                products: {
                                    '@media (min-width: 601px)': {
                                        'margin-left': '-20px',
                                    },
                                },
                            },
                        },
                        modalProduct: {
                            contents: {
                                img: false,
                                imgWithCarousel: true,
                                button: false,
                                buttonWithQuantity: true,
                            },
                            styles: {
                                product: {
                                    '@media (min-width: 601px)': {
                                        'max-width': '100%',
                                        'margin-left': '0px',
                                        'margin-bottom': '0px',
                                    },
                                },
                                button: {
                                    'font-size': getVar('--shopify-button-font-size'),
                                    'padding-top': '14.5px',
                                    'padding-bottom': '14.5px',
                                    'font-family': getVar('--shopify-button-font-family') + ' !important',
                                    'background-color': 'transparent',
                                    'color': '#5a0135',
                                    'border': '1px solid #5a0135',
                                    ':hover': {
                                        'background-color': 'transparent',
                                    },
                                    ':focus': {
                                        'background-color': 'transparent',
                                    },
                                    ':disabled': {
                                        'background-color': 'transparent',
                                        'background': 'transparent',
                                        'box-shadow': 'none',
                                        'border': 'none',
                                        'color': '#5a0135',
                                    },
                                    'border-radius': getVar('--shopify-button-border-radius'),
                                },
                                quantityInput: {
                                    'font-size': getVar('--shopify-button-font-size'),
                                    'padding-top': '14.5px',
                                    'padding-bottom': '14.5px',
                                    'color': '#5a0135',
                                },
                            },
                            googleFonts: ['Josefin Sans:700'],
                            text: {
                                button: 'ajouter au panier',
                                outOfStock: 'ajouter au panier',
                            },
                        },
                        option: {
                            styles: {
                                wrapper: {
                                    'border-radius': getVar('--shopify-button-border-radius'),
                                    'background-color': getVar('--shopify-option-wrapper-bg'),
                                },
                                select: {
                                    'color': '#5a0135',
                                },
                            },
                        },
                        cart: {
                            startOpen: false,
                            popup: false,
                            contents: {
                                close: true,
                            },
                            styles: {
                                header: {
                                    close: {
                                        'color': '#5a0135',
                                        'background-color': 'transparent',
                                        'border': 'none',
                                        'outline': 'none',
                                        'box-shadow': 'none',
                                        'font-family': '"Josefin Sans", sans-serif',
                                        ':hover': {
                                            'color': '#5a0135',
                                            'background-color': 'transparent',
                                        },
                                        ':focus': {
                                            'color': '#5a0135',
                                            'background-color': 'transparent',
                                            'outline': 'none',
                                            'box-shadow': 'none',
                                        },
                                        ':active': {
                                            'outline': 'none',
                                            'box-shadow': 'none',
                                            'background-color': 'transparent',
                                        },
                                        svg: {
                                            fill: '#5a0135',
                                        },
                                    },
                                },
                                base: {
                                    'font-family': '"Josefin Sans", sans-serif',
                                    'color': '#5a0135',
                                    'font-weight': '700',
                                },
                                cart: {
                                    'background-color': '#FFFFFF',
                                    'box-shadow': 'none',
                                    'font-weight': '700',
                                    // 'margin': '3rem',
                                    'height': 'calc(100% - 4.90rem)', // 7
                                    'width': 'calc(100% - 4.40rem)',
                                    'margin-top': '2.40rem', // 5 
                                    'margin-right': '2.5rem',


                                    '@media (max-width: 768px)': { // not working
                                        'margin-right': '1.8rem',

                                    },

                                    // 'box-sizing': 'border-box',
                                    /* 'right': '6rem',
                                    'width': 'calc(100% - 6rem)',
                                    'padding-bottom': '2rem', */
                                },
                                footer: {
                                    total: {
                                        'color': '#5a0135',
                                        'font-weight': '700',
                                        'font-family': '"Josefin Sans", sans-serif',
                                    },
                                },
                                title: {
                                    'font-family': '"Josefin Sans", sans-serif',
                                    'color': '#5a0135',
                                    'font-weight': '700',
                                },
                                lineItems: {
                                    'font-family': '"Josefin Sans", sans-serif',
                                    'color': '#5a0135',
                                    'font-weight': '700',
                                },
                                footer: {
                                    'font-family': '"Josefin Sans", sans-serif',
                                    'color': '#5a0135',
                                    'font-weight': '700',
                                },
                                notice: {
                                    'font-family': '"Josefin Sans", sans-serif',
                                    'color': '#5a0135',
                                    'font-weight': '700',
                                },
                                button: {
                                    'font-size': getVar('--shopify-button-font-size'),
                                    'padding-top': '10px',
                                    'padding-bottom': '10px',
                                    'font-family': '"Josefin Sans", sans-serif !important',
                                    'font-weight': '700',
                                    ':hover': {
                                        'background-color': 'transparent',
                                    },
                                    'background-color': getVar('--shopify-cart-button-bg'),
                                    'color': '#5a0135',

                                    'border': '1px solid #5a0135',
                                    ':focus': {
                                        'background-color': getVar('--shopify-cart-button-hover-bg'),
                                    },
                                    ':disabled': {
                                        'background-color': 'transparent',
                                        'background': 'transparent',
                                        'box-shadow': 'none',
                                        'border': 'none',
                                        'color': '#5a0135',
                                    },
                                    'border-radius': getVar('--shopify-button-border-radius'),
                                },
                            },
                            googleFonts: ['Josefin Sans:700'],
                            text: {
                                title: 'panier',
                                total: 'total',
                                button: 'COMMANDER',
                                outOfStock: 'sold out',
                                notice: 'les frais de port sont calculés au checkout.',
                            },
                        },
                        // Show only the decrement (minus) control in cart line items
                        lineItem: {
                            contents: {
                                quantity: true,
                            },
                            styles: {
                                title: {
                                    'font-size': '16px',
                                    'font-weight': '700',
                                },
                                // keep the quantity container visible but hide the numeric input
                                quantity: {},
                                quantityInput: {
                                    display: 'none',
                                },
                                // hide the increment (plus) button
                                quantityIncrement: {
                                    display: 'none',
                                },
                                // show the decrement (minus) button
                                quantityDecrement: {
                                    display: 'inline-block',
                                },
                            },
                        },
                        toggle: {
                            contents: {
                                count: false,
                                icon: false,
                                title: true,
                            },
                            text: {
                                title: 'panier',
                            },
                            styles: {
                                // PANIER BUTTON HIER
                                toggle: {
                                    'position': 'fixed',
                                    'top': '0',
                                    'right': '0',
                                    'padding-right': getVar('--padding-right'),
                                    'padding-top': getVar('--padding-top'),

                                    'padding-left': '0',
                                    'padding-bottom': '0',

                                    /*    '@media (max-width: 768px)': {
                                           'padding-left': '4rem',
   
                                           'padding-top': '1.5rem',
   
                                       }, */




                                    // 'top': '50px',
                                    //'right': '50px',
                                    'background-color': 'transparent',
                                    'border': 'none',
                                    // 'width': '200px',
                                    //  'height': '200px',
                                    'z-index': '1',
                                    /*  'width': '100vw',
                                     'height': '100vh', */
                                    //'cursor': 'none',
                                    'font-weight': '700',
                                    //'padding': getVar('--shopify-button-padding'), // change the positon of panier button
                                    'font-family': '"Josefin Sans", sans-serif',
                                    'font-size': getVar('--shopify-button-font-size'),
                                    ':hover': {
                                        'background-color': 'transparent',
                                    },
                                    ':focus': {
                                        'background-color': 'transparent',
                                    },

                                },
                                //bouton PANIER
                                title: {
                                    'font-family': '"Josefin Sans", sans-serif',
                                    'font-size': getVar('--shopify-button-font-size'),
                                    'color': '#5a0135',  //test
                                    /*  'color': 'blue', */
                                    'fontWeight': 700,

                                },
                                count: {
                                    'display': 'none',
                                },
                            },
                            googleFonts: ['Josefin Sans:700'],
                        },
                    },
                });




            }).catch((error) => {
                console.error('Shopify UI initialization error:', error);
            });
        }

        if (window.ShopifyBuy && window.ShopifyBuy.UI) {
            ShopifyBuyInit();
        } else {
            const script = document.createElement('script');
            script.async = true;
            script.src = scriptURL;
            script.onload = ShopifyBuyInit;
            script.onerror = () => console.error('Failed to load Shopify Buy Button script');
            (document.head || document.body).appendChild(script);
        }

        return () => {
            const node = document.getElementById(containerId);
            if (removeToggleListener) removeToggleListener();
        };
    }, [product]);

    if (!product) {
        return (
            <div className='productPage'>
                <div className='notFound'>
                    Product not found.
                    <button onClick={() => navigate('/')}>Back to Home</button>
                </div>
            </div>
        )
    }

    const captionParts = product.caption.split(' — ')
    const priceIndex = captionParts.findIndex(part => part.includes('€'))
    const mainInfoParts = priceIndex >= 0 ? captionParts.slice(0, priceIndex) : captionParts.slice(0, -1)
    const priceInfo = priceIndex >= 0 ? captionParts[priceIndex] : captionParts[captionParts.length - 1]

    const findPart = (keywords) => {
        const lower = keywords.map(k => k.toLowerCase())
        const idx = mainInfoParts.findIndex(p => lower.some(k => p.toLowerCase().includes(k)))
        if (idx === -1) return null
        return mainInfoParts[idx]
    }

    const orderedInfoCandidates = [
        product.titre || findPart(['titre']),
        product.taille || findPart(['taille', 'cm', 'size']),
        product.type || findPart(['type', 'cat', 'categorie', 'category']),
        product.matiere || findPart(['matiere', 'matière', 'material']),
        product.teinture || findPart(['teinture', 'teint', 'dyed']),
    ]
    const seen = new Set()
    const orderedMainInfo = orderedInfoCandidates.filter(Boolean).filter(item => {
        const key = item.trim()
        if (seen.has(key)) return false
        seen.add(key)
        return true
    })



    return (
        <div className='productPage' onClick={handleBackgroundClick}>

            {product?.productComponentId && (
                <div
                    id={`product-component-${product.productComponentId}`}
                    className='shopify-addtocard-button'
                /*   style={{

                      position: 'fixed',
                      left: '15%',
                      top: '50%',
                      transform: 'translate(-50%, -50%)',
                      width: '15vw',

                  }} */
                ></div>
            )}

            <div className='viewer'>
                {optimizedImages.length > 0 && (
                    <img
                        src={optimizedImages[index]}
                        alt={product.titre || 'Artwork'}
                        onClick={(e) => { e.stopPropagation(); handleClick(); }}
                    />
                )}
            </div>
            <div className='productCaption'>
                {orderedMainInfo.map((line, i) => (
                    <div key={i}>{line}</div>
                ))}
                <div >
                    {priceInfo}
                    <span className={`stockDot ${product.stock ? 'inStock' : 'outStock'}`} />
                </div>
            </div>

            {/*  <div className='cartButton'>
                <p>cart</p>
            </div>
 */}

            {/*  <div className='nextButton' onClick={handleClick}>cv
                <p>»</p>
            </div> */}
            {/*   <div className='closeButton' onClick={() => navigate(-1)}>
                <p>⤫</p>

            </div> */}
        </div>
    )
}

export default Product